import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Icon from "../common/icon/icon.component.jsx";
import OrderStatusTriggersList from './orderStatusTriggersList.component.jsx';


const orderStatuses = {
    completed: "completed",
    ordered: "ordered"
}

class OrderStatusListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            statuses: [],
            ordered: [],
            completed: [],
            triggers: [],
            headers: [],
            loading: false,
        }

        this.onSortCallback = this.onSortCallback.bind(this)
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })

        SideBar.activateMenu('account')
        this.refreshSearch()
    }

    componentWillUnmount() {
        AppContext.loadOrderStatuses()
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/order-statuses').then(r => {
            this.setState({
                statuses: r.data,
                headers: this.headers(),
                ordered: r.data.filter(s => s.attributes.type === 'ordered').map(q => this.row(q)),
                completed: r.data.filter(s => s.attributes.type === 'completed').map(q => this.row(q)),
                loading: false,
            })
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="listing.order_status.list.headers.name_label"
                defaultMessage="Name"
            />,
        ]
    }

    triggerRow(item) {
        let html = [
            <div><p>{item.TriggerKey}</p></div>
        ]
        return {
            rowId: item.TriggerKey,
            data: html
        }
    }

    row(item) {
        let html = [
            <Link to={"/order-statuses/" + item.id + '/edit'}>{item.attributes.name || "Unnamed"}</Link>
        ]
        return {
            rowId: item.id,
            data: html,
        }
    }

    onSortCallback(type) {
        return async (orderedData) => {
            var dto = { "ordering": [] }
            for(let row of orderedData) {
                dto["ordering"].push(row.rowId)
            }
            const response = await AppContext.getApiClient().put(`/order-statuses/ordering/${type}`, dto)
            if(response instanceof Error) {
                this.setState(this.state)
            } else if(type === 'ordered') {
                this.setState({
                    ordered: response.map( x => this.row(x) )
                })
            } else if(type === 'completed') {
                this.setState({
                    completed: response.map( x => this.row(x) )
                })
            }
        }
    }

    render() {
        let list =
            <div>

                <h3>
                    <span className={'badge badge-warning'}>
                        <FormattedMessage
                            id="listing.order_status.in_progress_label"
                            defaultMessage="In progress statuses"
                        />
                    </span>
                </h3>
                <StandardList
                    sortable={true}
                    didSorted={this.onSortCallback(orderStatuses.ordered)}
                    className="row pt-3"
                    headers={this.state.headers}
                    rows={this.state.ordered}
                    smallLine={true}
                    footer={
                        <div className="col-12 d-flex d-flex justify-content-start align-items-center">
                            <div>
                                <Link className="btn btn-primary btn-sm" to={'/order-statuses/ordered/new/' + this.state.ordered.length}>
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="listing.order_status.in_progress.new_btn"
                                        defaultMessage="Create a new 'In Progress' status"
                                    />
                                </Link>
                            </div>
                        </div>
                    }
                />

                <h3 className={'mt-3'}>
                    <span className={'badge badge-success'}>
                        <FormattedMessage
                            id="listing.order_status.completed_label"
                            defaultMessage="Completed statuses"
                        />
                    </span>
                </h3>
                <StandardList
                    sortable={true}
                    didSorted={this.onSortCallback(orderStatuses.completed)}
                    className="row pt-3"
                    headers={this.state.headers}
                    rows={this.state.completed}
                    smallLine={true}
                    footer={
                        <div className="col-12 d-flex d-flex justify-content-start align-items-center">
                            <div>
                                <Link className="btn btn-primary btn-sm" to={'/order-statuses/completed/new/' + this.state.completed.length}>
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="listing.order_status.completed.new_btn"
                                        defaultMessage="Create a new 'Completed' status"
                                    />
                                </Link>
                            </div>
                        </div>
                    }
                />

               <OrderStatusTriggersList
                    orderStatuses={ this.state.statuses }
                />

            </div>
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        return (
            <div className={'pt-4'}>
                {list}
            </div>
        );
    }
}

export default OrderStatusListing


// WEBPACK FOOTER //
// ./src/order-status/listing.component.jsx